import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, db } from './firebase';
import { ToastContainer } from "react-toastify";

import Login from './auth/Login';
import Register from './auth/Register';
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';

import Dashboard from './components/Dashboard';
import Forgetpass from './auth/Forgetpass';
import Disabled from './panel/Disabled';
import Uploaddocuments from './panel/Uploaddocuments';
import Notfound from './panel/Notfound';

import Course from './components/masters/submaster/Course';
import Property from './components/masters/master/Property';
import Feescat from './components/masters/master/Feescat';
import Bank from './components/masters/master/Bank';
import Castecat from './components/masters/master/Castecat';
import Religion from './components/masters/master/Religion';
import Location from './components/masters/master/Location';
import Medium from './components/masters/master/Medium';
import University from './components/masters/master/University';
import Examination from './components/masters/master/Examination';
import Bankaccounts from './components/masters/master/Bankaccounts';
import Document from './components/masters/master/Document';

import Collegetype from './components/masters/submaster/Collegetype';
import Branches from './components/masters/submaster/Bracnhes';
import NextClass from './components/masters/submaster/Nextclass';
import Subjectdef from './components/masters/submaster/Sujectdef';
import Feeheads from './components/masters/submaster/Feeheads';
import Studenttype from './components/masters/submaster/Studenttype';
import Schooldetails from './components/masters/master/Schooldetails';
import Help from './panel/Help';
import Usersmgmt from './panel/Usersmgmt';
import Admissionenquiry from './components/students/Admissionenquiry';
import Admissionstud from './components/students/Admissionstud';
import Admissionprocess from './components/students/Admissionprocess';
import Students from './components/students/Students';
import Academicyear from './components/masters/master/Academicyear';
import Classalocation from './components/students/Classalocation';
import StudentProfile from './components/students/StudentProfile';
import Dailyposts from './components/masters/master/Dailyposts';
import Biometric from './components/masters/master/Biometric';
import Studentbiometric from './components/masters/master/Studentbiometric';
import FingerprintScanner from './components/masters/master/FingerprintScanner';
import Documentupload from './components/students/Documentupload';
import Teachersmgmt from './components/teachers/Teachersmgmt';
import Teachersclass from './components/teachers/Teachersclass';
import Timetable from './components/teachers/Timetable';
import Homeworkallocation from './components/teachers/Homeworkallocation';

import Addcontacts from "./components/whatsapp/Addcontacts";
import Inactivecontacts from "./components/whatsapp/Inactivecontacts";
import Createpost from "./components/whatsapp/Createpost";
import Whatsapphistory from "./components/whatsapp/Whatsapphistory";
import Contactdivion from "./components/whatsapp/Contactdivion";
import Approvals from './components/Approvals';
import Notices from './components/Notices';

import Feestructuresetuo from './components/accounts/Feestructuresetuo';
import Feecollection from './components/accounts/Feecollection';
import Expense from './components/accounts/Expense';
import Income from './components/accounts/Income';

import Books from './components/library/Books';
import Issuebooks from './components/library/Issuebooks';
import Retursbooks from './components/library/Retursbooks';
import Guestenquiry from './components/masters/master/Guestenquiry';

import Vehicalmgmt from './components/vehicals/Vehicalmgmt';
import Vehicalmaintanance from './components/vehicals/Vehicalmaintanance';
import Fuellogs from './components/vehicals/Fuellogs';
import Drivermgmt from './components/vehicals/Drivermgmt';

import Hosteldetails from './components/hostel/Hosteldetails';
import Hostelrooms from './components/hostel/Hostelrooms';
import Hostelattendance from './components/hostel/Hostelattendance';
import Roomallocation from './components/hostel/Roomallocation';
import Wardendetails from './components/hostel/Wardendetails';
import Visitorlogs from './components/hostel/Visitorlogs';

import Productcategory from './components/store/Productcategory';
import Storeproducts from './components/store/Storeproducts';
import VendorMgmt from './components/store/Vendormgmt';
import Purchaseorders from './components/store/Purchaseorders';
import StudentInventory from './components/store/Studentinventory';

import Paymentallocation from './components/payroll/Paymentallocation';
import Payslip from './components/payroll/Payslip';
import Staffattendance from './components/payroll/Staffattendance';
import Advancepayment from './components/payroll/Advancepayment';
import Monthlypayments from './components/payroll/Monthlypayments';

import Canteenstaff from './components/canteen/Canteenstaff';
import Mealplanning from './components/canteen/Mealplanning';
import Canteenmenu from './components/canteen/Canteenmenu';
import Dailyentry from './components/canteen/Dailyentry';

import Locationtype from './components/transport/Locationtype';
import Locations from './components/transport/Locations';
import Driverallotment from './components/transport/Driverallotment';
import Passentry from './components/masters/master/Passentry';
import Studentassign from './components/transport/Studentassign';
import Academiccalender from './components/masters/master/Academiccalender';
import Holidays from './components/masters/master/Holidays';
import Examtypes from './components/masters/master/Examtypes';
import Posttypes from './components/masters/master/Posttypes';
import Staffdocuments from './components/masters/submaster/Staffdocuments';
import Hostelatttiming from './components/masters/submaster/Hostelatttiming';
import Studentattendance from './components/teachers/Studentattendance';
import Feeheadclassasign from './components/masters/master/Feeheadclassasign';
import Discountypes from './components/masters/submaster/Discountypes';

import Studentoutpass from './components/reception/Studentoutpass';
import Staffoutpass from './components/reception/Staffoutpass';
import Hosteloutpass from './components/reception/Hosteloutpass';
import Studentinpass from './components/reception/Studentinpass';

import Studentwallet from './components/students/Studentwallet';
import Chat from './panel/Chat';
import Parentsmgmt from './components/students/Parentsmgmt';
import Idcardgeneration from './components/students/Idcardgeneration';
import Videmeetings from './components/Videmeetings';

import Studentreport from './components/reports/Studentreport';
import Feesreport from './components/reports/Feesreport';
import Headwisecollection from './components/reports/Headwisecollection';
import Transportreport from './components/reports/Transportreport';
import Passentriesreport from './components/reports/Passentriesreport';
import Homeworkreport from './components/reports/Homeworkreport';
import Incomeexpreport from './components/reports/Incomeexpreport';
import Vehicalmainreport from './components/reports/Vehicalmainreport';
import Storeinventory from './components/reports/Storeinventory';
import Canteenreport from './components/reports/Canteenreport';
import Staffpayreport from './components/reports/Staffpayreport';

function App() {
  const [user, setUser] = useState();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
    });
  });


  return (
    <div className="wrapper">
      <Router>

        {
          !user ?
            <Routes>
              <Route path='/' element={<Login />} />
              <Route path='/login' element={<Login />} />
              {/* <Route path='/Register' element={<Register />} /> */}
              <Route path='/forgot-password' element={<Forgetpass />} />
            </Routes>
            :
            <>
              <Header />
              <Menu />
              <div className='content-wrapper p-3' style={{ marginBottom: 50 }}>
                <Routes>

                  <Route path="/staff-payment-report" element={<Staffpayreport />} />
                  <Route path="/canteen-report" element={<Canteenreport />} />
                  <Route path="/store-inventories" element={<Storeinventory />} />
                  <Route path="/vehical-maintance-report" element={<Vehicalmainreport />} />
                  <Route path="/income-expense-report" element={<Incomeexpreport />} />
                  <Route path="/homework-reports" element={<Homeworkreport />} />
                  <Route path="/pass-entries" element={<Passentriesreport />} />
                  <Route path="/transport-reports" element={<Transportreport />} />
                  <Route path="/fee-headwise-collection" element={<Headwisecollection />} />
                  <Route path="/fee-reports" element={<Feesreport />} />
                  <Route path="/students-reports" element={<Studentreport />} />

                  <Route path="/chat" element={<Chat />} />
                  <Route path="/student-wallet" element={<Studentwallet />} />
                  <Route path="/parents-mgmt" element={<Parentsmgmt />} />
                  <Route path="/id-card-generation" element={<Idcardgeneration />} />
                  <Route path="/video-mettings" element={<Videmeetings />} />

                  <Route path="/student-hostel-inpass" element={<Studentinpass />} />
                  <Route path="/student-hostel-outpass" element={<Hosteloutpass />} />
                  <Route path="/staff-outpass" element={<Staffoutpass />} />
                  <Route path="/student-outpass" element={<Studentoutpass />} />

                  <Route path="/fee-discount-types" element={<Discountypes />} />
                  <Route path="/fee-head-class-assigning" element={<Feeheadclassasign />} />
                  <Route path="/student-attendance" element={<Studentattendance />} />
                  <Route path="/hostel-attendance-timing" element={<Hostelatttiming />} />
                  <Route path="/staff-dcouments" element={<Staffdocuments />} />
                  <Route path="/exam-types" element={<Examtypes />} />

                  <Route path="/pass-entry" element={<Passentry />} />
                  <Route path="/student-assigning" element={<Studentassign />} />
                  <Route path="/driver-allotment" element={<Driverallotment />} />
                  <Route path="/transport-location" element={<Locations />} />
                  <Route path="/location-types" element={<Locationtype />} />

                  <Route path="/canteen-staff" element={<Canteenstaff />} />
                  <Route path="/meal-planning" element={<Mealplanning />} />
                  <Route path="/canteen-menu" element={<Canteenmenu />} />
                  <Route path="/canteen-daily-entry" element={<Dailyentry />} />

                  <Route path="/payment-allocation" element={<Paymentallocation />} />
                  <Route path="/payslips" element={<Payslip />} />
                  <Route path="/attendance" element={<Staffattendance />} />
                  <Route path="/advance-payment" element={<Advancepayment />} />
                  <Route path="/monthly-payment" element={<Monthlypayments />} />

                  <Route path="/student-inventory" element={<StudentInventory />} />
                  <Route path="/purchase-orders" element={<Purchaseorders />} />
                  <Route path="/vendors" element={<VendorMgmt />} />
                  <Route path="/store-products" element={<Storeproducts />} />
                  <Route path="/product-category" element={<Productcategory />} />

                  <Route path="/hostel-details" element={<Hosteldetails />} />
                  <Route path="/hostel-rooms" element={<Hostelrooms />} />
                  <Route path="/warden" element={<Wardendetails />} />
                  <Route path="/room-allocation" element={<Roomallocation />} />
                  <Route path="/hostel-attendance" element={<Hostelattendance />} />
                  <Route path="/visitor-log" element={<Visitorlogs />} />

                  <Route path="/drivers" element={<Drivermgmt />} />
                  <Route path="/fuel-logs" element={<Fuellogs />} />
                  <Route path="/vehicle-maintenance" element={<Vehicalmaintanance />} />
                  <Route path="/vehicles" element={<Vehicalmgmt />} />

                  <Route path="/guest-enquiry" element={<Guestenquiry />} />
                  <Route path="/return-books" element={<Retursbooks />} />
                  <Route path="/issue-books" element={<Issuebooks />} />
                  <Route path="/books" element={<Books />} />

                  <Route path="/income" element={<Income />} />
                  <Route path="/expenses" element={<Expense />} />
                  <Route path="/fee-collection" element={<Feecollection />} />
                  <Route path="/fee-structure" element={<Feestructuresetuo />} />

                  <Route path="/notices" element={<Notices />} />
                  <Route path="/approvals" element={<Approvals />} />

                  <Route path="/contacts-divison" element={<Contactdivion />} />
                  <Route path="/whatsapp-history" element={<Whatsapphistory />} />
                  <Route path="/send-whatsapp" element={<Createpost />} />
                  <Route path="/active-contacts" element={<Addcontacts />} />
                  <Route path="/inactive-contacts" element={<Inactivecontacts />} />

                  <Route path="/homework-allocation" element={<Homeworkallocation />} />
                  <Route path="/teacher-timetable" element={<Timetable />} />
                  <Route path="/teacher-class-allocation" element={<Teachersclass />} />
                  <Route path="/teachers" element={<Teachersmgmt />} />

                  <Route path="/student-documents" element={<Documentupload />} />
                  <Route path="/scan-check" element={<FingerprintScanner />} />
                  <Route path="/student-biometric" element={<FingerprintScanner />} />
                  {/* <Route path="/student-biometric" element={<Studentbiometric />} /> */}
                  <Route path="/biometric" element={<Biometric />} />
                  <Route path="/daily-posts" element={<Dailyposts />} />
                  <Route path="/student-profile/:studentId" element={<StudentProfile />} />
                  <Route path="/class-allocation" element={<Classalocation />} />
                  <Route path="/students" element={<Students />} />
                  <Route path="/admission/:studentId" element={<Admissionstud />} />
                  <Route path="/admission-process" element={<Admissionprocess />} />
                  <Route path="/admission-enquiry" element={<Admissionenquiry />} />
                  <Route path="/users-mgmt" element={<Usersmgmt />} />
                  <Route path="/school-details" element={<Schooldetails />} />
                  <Route path="/student-type" element={<Studenttype />} />
                  <Route path="/fee-head-master" element={<Feeheads />} />
                  <Route path="/subject-definition" element={<Subjectdef />} />
                  <Route path="/next-class-definition" element={<NextClass />} />
                  <Route path="/branches" element={<Branches />} />
                  <Route path="/college-type" element={<Collegetype />} />
                  <Route path="/academic-calender" element={<Academiccalender />} />
                  <Route path="/holidays" element={<Holidays />} />
                  <Route path="/post-types" element={<Posttypes />} />

                  <Route path="/document-mgmt" element={<Document />} />
                  <Route path="/academic-years" element={<Academicyear />} />
                  <Route path="/bank-accounts" element={<Bankaccounts />} />
                  <Route path="/examination" element={<Examination />} />
                  <Route path="/board" element={<University />} />
                  <Route path="/mediums" element={<Medium />} />
                  <Route path="/locations" element={<Location />} />
                  <Route path="/banks" element={<Bank />} />
                  <Route path="/religion" element={<Religion />} />
                  <Route path="/caste-category" element={<Castecat />} />
                  <Route path="/fees-category" element={<Feescat />} />
                  <Route path="/property-details" element={<Property />} />
                  <Route path="/courses" element={<Course />} />
                  <Route path='*' element={<Notfound />} />
                  <Route path='/' element={<Dailyentry />} />
                  <Route path='/home' element={<Dailyentry />} />
                  <Route path='/disabled-property' element={<Disabled />} />
                  <Route path='/property-documents' element={<Uploaddocuments />} />
                  <Route path='/help-support' element={<Help />} />
                </Routes>

              </div>
              <Footer />
            </>
        }
      </Router>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </div >
  );
}

export default App;
